import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-uikit/Dropdown";

interface DeleteProps {
  onClick: () => void;
}

export const Delete = ({ onClick }: DeleteProps) => (
  <Dropdown.ItemWithLink hasDanger onClick={onClick}>
    {t("settings.workflows.table.actions.delete")}
  </Dropdown.ItemWithLink>
);
